export default "__VITE_ASSET__CbDtL7xq__"